import { baseUrlUsers as users } from "./endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsPreferences = {
  getSpatialControlsPreference: () => `${users}/Preferences/controls`,
  setSpatialControlsPreference: (controlScheme: string) =>
    ({
      method: "PUT",
      url: `${users}/Preferences/controls`,
      body: controlScheme,
    }) as Endpoint,
};
